import { ApolloLink } from '@apollo/client';

function recordOperation(recordingFn) {
    return new ApolloLink(function (operation, forward) {
        var observable = forward(operation);
        if (!observable.map) {
            return observable;
        }
        return forward(operation).map(function (result) {
            if ('operation' in operation.query.definitions[0]) {
                return recordingFn(operation.query.definitions[0].operation, operation.operationName, operation.variables, result);
            }
            else {
                return result;
            }
        });
    });
}

export default recordOperation;
//# sourceMappingURL=recordOperation.js.map
